export default [
  {
    type: "textarea",
    name: "remarks",
    label: "Remarks",
    validation: "required",
  }
];
